import React from "react"
import * as Yup from "yup"
import { Stack, Text } from "@chakra-ui/react"
import { exportLeadRetrievalLeads } from "api/events"
import { successToast } from "utilities/toasts"
import { EMAIL_VALIDATION_REGEX } from "utilities/constants"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import TextField from "components/ReactHookForm/TextField"

const ExportLeadsSchema = Yup.object().shape({
  email: Yup.string().matches(EMAIL_VALIDATION_REGEX, "Invalid email format").required(),
})

type Props = {
  eventId: string
  eventAccessId: number
  onBack: () => void
  onHide: () => void
}

const ExportLeads = ({
  eventId, eventAccessId, onBack, onHide,
}: Props) => {
  const onSubmit = (values) => exportLeadRetrievalLeads(
    eventId, eventAccessId, values.email,
  ).then(() => {
    successToast({ title: `Sent leads CSV to ${values.email}` })
    onHide()
  })

  return (
    <ModalForm
      title="Export CSV"
      onClose={onHide}
      onBack={onBack}
      initialValues={{ email: "" }}
      validationSchema={ExportLeadsSchema}
      onSubmit={onSubmit}
      submitText="Send"
      size="lg"
    >
      {({ control }) => (
        <Stack spacing={0}>
          <Text mb={4}>
            Send this exhibitor&apos;s scanned leads as a CSV file to the email address below.
          </Text>
          <TextField
            vertical
            label="Recipient Email"
            name="email"
            control={control}
            variant="outline"
            placeholder="Enter email address"
          />
        </Stack>
      )}
    </ModalForm>
  )
}

export default ExportLeads
